const getters = {
  parcels: state => state.parcels,
  parcel: state => state.parcel,
  parcelSet: state => state.parcel_set,
  parcelFilters: state => state.parcel_filters,
  parcelGroups: state => state.parcel_groups,
}

export default getters;
